import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import t from '../../../../translations';
// uses ./AppDomainSettings.less
import Icon from '../../../common/Icon';

const AppDomainSettingsActionBoxConfigure = ({ openSettings, userManual, onClickLink }) => (
    <>
        <div className="ast-app-configuration__information-box">
            <Icon alias="info" />
            <div className="ast-app-configuration__information">
                <p className="txt-semi-bold">{t.AppDomainSettings.mainInformation}</p>
                {userManual && (
                    <p>
                        {t.AppDomainSettings.userManualInformation.part_1}
                        <a href={userManual} target="_blank" rel="noreferrer" onClick={onClickLink}>
                            {t.AppDomainSettings.userManualInformation.linkName}
                        </a>
                        {t.AppDomainSettings.userManualInformation.part_2}
                    </p>
                )}
            </div>
        </div>
        <div className="ast-app-configuration__action-box">
            <div>
                <p className="txt-semi-bold">
                    {t.AppDomainSettings.configuration}
                    <span className="ast-app-configuration__label-required">{t.AppDomainSettings.required}</span>
                </p>
                <p className="sg-txt-light">{t.AppDomainSettings.subInformationConfigure}</p>
            </div>
            <button type="button" onClick={openSettings} className="sg-button-action ast-app-configuration__link">
                {t.AppDomainSettings.buttonConfigure}
            </button>
        </div>
    </>
);

AppDomainSettingsActionBoxConfigure.propTypes = {
    openSettings: PropTypes.func.isRequired,
    userManual: PropTypes.string,
    onClickLink: PropTypes.func.isRequired,
};

export default AppDomainSettingsActionBoxConfigure;
